import React from "react";
import { Layout } from "antd";
import { Link } from "react-router-dom"; 

// Layout ke components yahan import ho gaye hain
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

import CarNoBg from '../assets/images/Saloon PNG.png';
import SuvPng from '../assets/images/SUV-PNG.png';
import VanPng from '../assets/images/van.png'; 
import BusPng from '../assets/images/bus.png'; 
import TransBg from '../assets/qhsawari.jpeg'; 
import homepagetopbtn from '../assets/homepage-topbtn.png';
import Icon1 from '../assets/icon1.png'; 
import Icon2 from '../assets/icon2.png';
import Icon3 from '../assets/icon3.png';
import SuiteCase from '../assets/suitecase.png';
import Person from '../assets/person.png';
import kar from '../assets/karachi.jpg';
import lah from '../assets/lahore.jpg';
import nar from '../assets/naran.jpg';
import skardu from '../assets/skardu.jpg';

const { Content } = Layout;

export default function Landing() {

  const heroData = {
    bgImage: TransBg,
    title: "Reliable Airport Transfers, Vehicle Rentals and Tourism Service Across Pakistan",
    };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
      
      {/* ================= GLOBAL LAYOUT HEADER ================= */}
      <Header />

      {/* ================= MAIN CONTENT ================= */}
      <div className="flex-grow flex flex-col">
        
        {/* HERO BANNER */}
        <Content 
          className="relative min-h-[450px] md:min-h-[500px] flex items-center justify-center text-center px-6 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroData.bgImage})` }} 
        >
          <div className="absolute inset-0 bg-black/40 pointer-events-none z-0"></div>

          <div className="max-w-3xl mx-auto relative z-10 px-4 flex flex-col items-center pt-12">
            <h1 
              className="!text-white font-extrabold text-2xl sm:text-3xl md:text-4xl leading-tight tracking-wide uppercase mb-4 drop-shadow-2xl"
              style={{ color: '#ffffff', textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}
            >
              {heroData.title}
            </h1>
            
            <p 
              className="!text-white text-xs sm:text-sm md:text-base font-light max-w-xl mx-auto mb-6 leading-relaxed drop-shadow-md"
              style={{ color: '#ffffff', textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}
            >
              {heroData.description}
            </p>
            
            <div className="mb-8 select-none">
              <img 
                src={homepagetopbtn} 
                alt="Featured Action Indicator" 
                className="h-14 sm:h-16 w-auto object-contain drop-shadow-[0_0_18px_rgba(253,224,71,0.9)] filter transition-all duration-300 hover:scale-105"
              />
            </div>

            <Link to="/services" className="inline-block bg-[#00401A] hover:bg-emerald-950 text-white text-base font-semibold px-8 py-3.5 rounded-lg shadow-lg border border-emerald-500/30 transition-all transform hover:scale-105 uppercase tracking-wider">
              Book Your Journey
            </Link>
          </div>
        </Content>

        {/* FLOATING FEATURE BAR */}
        <div className="max-w-6xl mx-auto w-[90%] bg-white rounded-xl shadow-xl border border-gray-100 p-4 -mt-8 relative z-20 grid grid-cols-2 lg:grid-cols-4 gap-4 text-center divide-x divide-gray-100">
          <div className="flex items-center justify-center space-x-2 md:space-x-3 py-2">
            <img src={Icon1} alt="Instant Quotes" className="w-6 h-6 md:w-8 md:h-8 object-contain rounded-md" />
            <span className="font-semibold text-gray-700 text-xs md:text-sm lg:text-base whitespace-nowrap">Instant Quotes</span>
          </div>
          <div className="flex items-center justify-center space-x-2 md:space-x-3 py-2">
            <img src={Icon2} alt="Easy Online Booking" className="w-6 h-6 md:w-8 md:h-8 object-contain rounded-md" />
            <span className="font-semibold text-gray-700 text-xs md:text-sm lg:text-base whitespace-nowrap">Easy Online Booking</span>
          </div>
          <div className="flex items-center justify-center space-x-2 md:space-x-3 py-2">
            <img src={Icon2} alt="Secure Payments" className="w-6 h-6 md:w-8 md:h-8 object-contain rounded-md" />
            <span className="font-semibold text-gray-700 text-xs md:text-sm lg:text-base whitespace-nowrap">Secure Payments</span>
          </div>
          <div className="flex items-center justify-center space-x-2 md:space-x-3 py-2">
            <img src={Icon3} alt="24/7 Support" className="w-6 h-6 md:w-8 md:h-8 object-contain rounded-md" />
            <span className="font-semibold text-gray-700 text-xs md:text-sm lg:text-base whitespace-nowrap">24/7 Support</span>
          </div>
        </div>

        {/* SERVICES & DESTINATIONS SECTIONS */}
        <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 w-full grid grid-cols-1 lg:grid-cols-12 gap-12">
          
          {/* EXCLUSIVE SERVICES */}
          <div className="lg:col-span-12 flex flex-col">
            <h2 className="text-xl md:text-2xl font-extrabold text-gray-900 uppercase tracking-wide mb-6 border-b-2 border-emerald-800 pb-2 inline-block self-start">
              Our Exclusive Services
            </h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {/* Card 1: Corolla */}
              <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm flex flex-col justify-between hover:shadow-md transition">
                <div className="w-full bg-gray-50 p-2 flex items-center justify-center overflow-hidden relative">
                  <img src={CarNoBg} alt="Premium Sedan Corolla" className="w-full h-32 sm:h-40 md:h-48 object-contain" />
                  <div className="absolute bottom-2 left-2 flex items-center gap-1.5 bg-white/90 backdrop-blur-xs px-2 py-1 rounded-md shadow-xs">
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={Person} alt="Passengers" className="w-3 h-3 mr-1 object-contain" />
                      <span>4</span>
                    </div>
                    <span className="text-gray-300 text-[10px]">|</span>
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={SuiteCase} alt="Luggage" className="w-3 h-3 mr-1 object-contain" />
                      <span>2</span>
                    </div>
                  </div>
                </div>
                <div className="p-3 flex-grow flex flex-col justify-between border-t border-gray-100">
                  <div>
                    <h3 className="font-bold text-xs uppercase text-gray-900 mb-2">Premium Sedan</h3>
                    <ul className="text-[11px] text-gray-600 space-y-1 list-disc list-inside mb-3">
                      <li>Airport transfer service</li>
                      <li>Day, week or month hire with driver</li>
                      <li>Tourism bookings with driver</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Card 2: Prado */}
              <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm flex flex-col justify-between hover:shadow-md transition">
                <div className="w-full bg-gray-50 p-2 flex items-center justify-center overflow-hidden relative">
                  <img src={SuvPng} alt="Adventure SUV Prado" className="w-full h-32 sm:h-40 md:h-48 object-contain" />
                  <div className="absolute bottom-2 left-2 flex items-center gap-1.5 bg-white/90 backdrop-blur-xs px-2 py-1 rounded-md shadow-xs">
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={Person} alt="Passengers" className="w-3 h-3 mr-1 object-contain" />
                      <span>4</span>
                    </div>
                    <span className="text-gray-300 text-[10px]">|</span>
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={SuiteCase} alt="Luggage" className="w-3 h-3 mr-1 object-contain" />
                      <span>4</span>
                    </div>
                  </div>
                </div>
                <div className="p-3 flex-grow flex flex-col justify-between border-t border-gray-100">
                  <div>
                    <h3 className="font-bold text-xs uppercase text-gray-900 mb-2">Executive SUV</h3>
                    <ul className="text-[11px] text-gray-600 space-y-1 list-disc list-inside mb-3">
                      <li>Airport transfer service</li>
                      <li>Day, week or month hire with driver</li>
                      <li>Tourism bookings with driver</li>
                      <li>Corporate and VIP Services</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Card 3: Executive Van */}
              <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm flex flex-col justify-between hover:shadow-md transition">
                <div className="w-full bg-gray-50 p-2 flex items-center justify-center overflow-hidden relative">
                  <img src={VanPng} alt="Executive Van" className="w-full h-32 sm:h-40 md:h-48 object-contain transform scale-90" />
                  <div className="absolute bottom-2 left-2 flex items-center gap-1.5 bg-white/90 backdrop-blur-xs px-2 py-1 rounded-md shadow-xs">
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={Person} alt="Passengers" className="w-3 h-3 mr-1 object-contain" />
                      <span>14</span>
                    </div>
                    <span className="text-gray-300 text-[10px]">|</span>
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={SuiteCase} alt="Luggage" className="w-3 h-3 mr-1 object-contain" />
                      <span>8</span>
                    </div>
                  </div>
                </div>
                <div className="p-3 flex-grow flex flex-col justify-between border-t border-gray-100">
                  <div>
                    <h3 className="font-bold text-xs uppercase text-gray-900 mb-2">Executive Van</h3>
                    <ul className="text-[11px] text-gray-600 space-y-1 list-disc list-inside mb-3">
                      <li>Airport transfer service</li>
                      <li>Day, week or month hire with driver</li>
                      <li>Tourism bookings with driver</li>
                      <li>Corporate and VIP Services</li>
                      <li>Group events and trips</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Card 4: Luxury Bus */}
              <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm flex flex-col justify-between hover:shadow-md transition">
                <div className="w-full bg-gray-50 p-2 flex items-center justify-center overflow-hidden relative">
                  <img src={BusPng} alt="Luxury Bus" className="w-full h-32 sm:h-40 md:h-48 object-contain transform scale-135" />
                  <div className="absolute bottom-2 left-2 flex items-center gap-1.5 bg-white/90 backdrop-blur-xs px-2 py-1 rounded-md shadow-xs">
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={Person} alt="Passengers" className="w-3 h-3 mr-1 object-contain" />
                      <span>20</span>
                    </div>
                    <span className="text-gray-300 text-[10px]">|</span>
                    <div className="flex items-center text-[10px] font-bold text-gray-700">
                      <img src={SuiteCase} alt="Luggage" className="w-3 h-3 mr-1 object-contain" />
                      <span>20</span>
                    </div>
                  </div>
                </div>
                <div className="p-3 flex-grow flex flex-col justify-between border-t border-gray-100">
                  <div>
                    <h3 className="font-bold text-xs uppercase text-gray-900 mb-2">Corporate & Luxury Bus</h3>
                    <ul className="text-[11px] text-gray-600 space-y-1 list-disc list-inside mb-3">
                      <li>Airport transfer service</li>
                      <li>Day, week or month hire with driver</li>
                      <li>Tourism bookings with driver</li>
                      <li>Corporate and VIP Services</li>
                      <li>Group events and trips</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* POPULAR DESTINATIONS AREA */}
          <div className="lg:col-span-12 flex flex-col mt-10">
            <h2 className="text-xl md:text-2xl font-extrabold text-gray-900 uppercase tracking-wide mb-6 border-b-2 border-emerald-800 pb-2 inline-block self-start">
              Popular Destinations
            </h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 items-stretch">
              {/* Destination 1: Skardu */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition duration-300 flex flex-col h-full">
                <img src={skardu} alt="Skardu" className="w-full h-48 md:h-56 object-cover flex-shrink-0" />
                <div className="p-4 flex flex-col flex-grow">
                  <h4 className="font-extrabold text-base text-emerald-950 mb-2">Skardu</h4>
                  <p className="text-xs text-gray-600 leading-relaxed font-light flex-grow">
                    The capital of Baltistan division, nestled at 2,500m elevation. Home to surreal cold deserts, majestic blue lakes, and the spectacular confluence of the Indus and Shigar rivers.
                  </p>
                </div>
              </div>

              {/* Destination 2: Naran */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition duration-300 flex flex-col h-full">
                <img src={nar} alt="Naran" className="w-full h-48 md:h-56 object-cover flex-shrink-0" />
                <div className="p-4 flex flex-col flex-grow">
                  <h4 className="font-extrabold text-base text-emerald-950 mb-2">Naran</h4>
                  <p className="text-xs text-gray-600 leading-relaxed font-light flex-grow">
                    Pakistan's premier alpine paradise in the upper Kaghan Valley. Situated at 2,409m, it features lush green valleys, rushing streams, and the legendary Saif-ul-Malook Lake.
                  </p>
                </div>
              </div>

              {/* Destination 3: Lahore */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition duration-300 flex flex-col h-full">
                <img src={lah} alt="Lahore" className="w-full h-48 md:h-56 object-cover flex-shrink-0" />
                <div className="p-4 flex flex-col flex-grow">
                  <h4 className="font-extrabold text-base text-emerald-950 mb-2">Lahore</h4>
                  <p className="text-xs text-gray-600 leading-relaxed font-light flex-grow">
                    The historic cultural capital of Punjab and Pakistan's second-largest city. Renowned for its rich Mughal architecture, vibrant food streets, and progressive, cosmopolitan spirit.
                  </p>
                </div>
              </div>

              {/* Destination 4: Karachi */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition duration-300 flex flex-col h-full">
                <img src={kar} alt="Karachi" className="w-full h-48 md:h-56 object-cover flex-shrink-0" />
                <div className="p-4 flex flex-col flex-grow">
                  <h4 className="font-extrabold text-base text-emerald-950 mb-2">Karachi</h4>
                  <p className="text-xs text-gray-600 leading-relaxed font-light flex-grow">
                    Pakistan's premier industrial and financial beta-global hub along the Arabian Sea. A sprawling, ethnically diverse coastal megacity famously known as the City of Lights.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ SECTION */}
          <div className="lg:col-span-12 flex flex-col mt-12">
            <h2 className="text-xl md:text-2xl font-extrabold text-gray-900 uppercase tracking-wide mb-6 border-b-2 border-emerald-800 pb-2 inline-block self-start">
              Frequently Asked Questions
            </h2>
            
            <div className="space-y-4 max-w-4xl">
              <details className="group bg-white border border-gray-200 rounded-xl p-4 [&_summary::-webkit-details-marker]:hidden cursor-pointer transition shadow-xs">
                <summary className="flex items-center justify-between text-sm md:text-base font-semibold text-gray-800 list-none">
                  <span>How can I book a vehicle with Sawari?</span>
                  <span className="transition group-open:-rotate-180 text-emerald-800 font-bold">▼</span>
                </summary>
                <p className="mt-3 text-xs md:text-sm text-gray-600 leading-relaxed">
                  Aap hamari website par direct select karke smoothly book kar sakte hain, ya phir diye gaye contact number par rabta karke custom quotation bhi le sakte hain.
                </p>
              </details>

              <details className="group bg-white border border-gray-200 rounded-xl p-4 [&_summary::-webkit-details-marker]:hidden cursor-pointer transition shadow-xs">
                <summary className="flex items-center justify-between text-sm md:text-base font-semibold text-gray-800 list-none">
                  <span>Are drivers included in the rental charges?</span>
                  <span className="transition group-open:-rotate-180 text-emerald-800 font-bold">▼</span>
                </summary>
                <p className="mt-3 text-xs md:text-sm text-gray-600 leading-relaxed">
                  Ji haan, hamari tamam transport services professional aur experienced drivers ke sath aati hain taake aapka safar bilkul mehfooz aur aaramdeh rahe.
                </p>
              </details>

              <details className="group bg-white border border-gray-200 rounded-xl p-4 [&_summary::-webkit-details-marker]:hidden cursor-pointer transition shadow-xs">
                <summary className="flex items-center justify-between text-sm md:text-base font-semibold text-gray-800 list-none">
                  <span>What is the cancellation policy?</span>
                  <span className="transition group-open:-rotate-180 text-emerald-800 font-bold">▼</span>
                </summary>
                <p className="mt-3 text-xs md:text-sm text-gray-600 leading-relaxed">
                  Safar shuru hone se 24 ghante pehle cancellation bilkul free hai. Last-moment cancel karne par short processing fee deduct ho sakti hai.
                </p>
              </details>
            </div>
          </div>

        </section>
      </div>

      {/* ================= GLOBAL LAYOUT FOOTER ================= */}
      <Footer />
    </div>
  );
}